// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "toolbarCheckbox__wrapper-24BzS";
export { _1 as "__esModule", _2 as "toolbarCheckbox__wrapper" }
export default { "__esModule": _1, "toolbarCheckbox__wrapper": _2 }
